{
    "GenericAdminFilterLanguage_CME_LABEL": "FMC",
    "GenericAdminFilterLanguage_TELSYS_LABEL": "Serveur de téléphonie",
    "GenericAdminFilterLanguage_PARTITION_LABEL": "Partition",
    "GenericAdminFilterLanguage_CRM_TYPE_LABEL": "Type de CRM",
    "GenericAdminFilterLanguage_INCLUDE_CHILD_CMES_LABEL": "Inclure les éléments de formation médicale continue pour les enfants",
    "GenericAdminFilterLanguage_SEARCH_LABEL": "Recherche",
    "NAME": "GenericAdminFilterLanguage",
    "GenericAdminFilterLanguage_OPTION_ALL_LABEL": "Tous",
    "GenericAdminFilterLanguage_OPTION_ANY_LABEL": "N'importe lequel",
    "GenericAdminFilterLanguage_OPTION_NONE_LABEL": "Aucun",
    "GenericAdminFilterLanguage_PLEASE_SELECT_OPTION_TO_SHOW_RESULTS": "Veuillez sélectionner une option pour afficher les résultats."
}